import { baseProductFilterSchema } from "@redotech/redo-product-common/product-filters/product-filters-db-parser";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const updateProductFilter = {
  name: "updateProductFilter" as const,
  input: z.object({
    _id: zExt.objectId(),
    updatedFilter: baseProductFilterSchema,
  }),
  output: z.intersection(
    z.object({ _id: zExt.objectId() }),
    baseProductFilterSchema,
  ),
};
